<template>
  <div class="reel-wrapper">
    <div
      class="reel-frame"
      :style="{
        backgroundImage: `url(${post?.file?.preview})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }"
    >
      <!-- Reels Label and Camera Icon -->
      <div class="top-bar d-flex justify-space-between align-center px-4 pt-3">
        <span class="text-white font-weight-bold">Reels</span>
        <v-icon color="white">mdi-camera-outline</v-icon>
      </div>

      <!-- Background Reels Image -->
      <div v-if="post?.file">
        <video
          v-if="
            post?.file?.file &&
            post?.file?.file?.type &&
            post?.file?.file?.type.startsWith('video/')
          "
          height="100%"
          :src="post.file.preview"
          autoplay
          muted
          loop
          class="media-type"
        ></video>
      </div>

      <!-- Bottom Overlay Info -->
      <div class="overlay-content">
        <!-- Left: User Info and Caption -->
        <div class="left-info d-flex flex-column justify-end">
          <div class="d-flex align-center mb-2">
            <v-avatar size="28" class="me-2">
              <img src="https://i.pravatar.cc/40" />
            </v-avatar>
            <span class="text-white font-weight-bold">your.name</span>
          </div>
          <div class="text-white text-body-2 mb-1">
            Lorem menus portion gurus denim. Non et Ma...
          </div>
          <div class="text-caption text-white text-opacity-75">
            🎵 Lore menus portion gurus denim.
          </div>
        </div>

        <!-- Right: Action Icons -->
        <div class="right-icons d-flex flex-column align-center">
          <v-icon class="text-white mb-4">mdi-heart-outline</v-icon>
          <v-icon class="text-white mb-4">mdi-comment-outline</v-icon>
          <v-icon class="text-white mb-4">mdi-send-outline</v-icon>
          <v-icon class="text-white mb-4">mdi-dots-horizontal</v-icon>
        </div>
      </div>

      <!-- Bottom Navigation Bar -->
      <div
        class="bottom-nav d-flex justify-space-around align-center px-4 py-2"
      >
        <v-icon color="white">mdi-home-outline</v-icon>
        <v-icon color="white">mdi-magnify</v-icon>
        <v-icon color="white">mdi-play-box-multiple</v-icon>
        <v-icon color="white">mdi-account-circle-outline</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { publishPost } from "@/store/publishPost/publishPost.js";
export default {
  name: "InstgramReelReview",
  components: {},
  data() {
    return {
      store: publishPost(),
      post: {},
    };
  },
  watch: {
    "store.getCarouselSlider": {
      handler() {
        this.post = this.store.post["instagram"].find(
          (item) => item.type === "reel"
        );
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.reel-wrapper {
  width: 100%;
  max-width: 420px;
  aspect-ratio: 9 / 16;
  position: relative;
}

.reel-frame {
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 28px;
  overflow: hidden;
  background: #000;
}

/* Top bar */
.top-bar {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6), transparent);
}

/* Overlay bottom info (text + icons) */
.overlay-content {
  position: absolute;
  bottom: 60px;
  left: 0;
  z-index: 10;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
}

/* Left info area */
.left-info {
  width: 75%;
}

/* Right icons area */
.right-icons {
  width: 25%;
}

/* Bottom navigation bar */
.bottom-nav {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  z-index: 10;
}

.video-background ::v-deep(.v-img__img) {
  object-position: center center;
}
</style>
